/* import __COLOCATED_TEMPLATE__ from './layout-module.hbs'; */
/* RESPONSIBLE TEAM: team-actions */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';

interface Args {
  headerTitle?: string;
}

interface Signature {
  Args: Args;
  Blocks: {
    actions: [];
    additionalInfo: [];
    content: [];
  };
  Element: HTMLElement;
}

export default class LayoutModule extends Component<Signature> {
  @service declare router: RouterService;

  get highlightPreviewSection(): boolean {
    return this.router.currentRoute?.queryParams?.section === 'preview';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::Preview::LayoutModule': typeof LayoutModule;
    'workflows/preview/layout-module': typeof LayoutModule;
  }
}
